import {
    Button,
    Card,
    Col,
    Form,
    Modal,
    Row,
    Tab,
    Tabs,
    Container,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useEffect, useState } from "react";
import { websitePlanPropType } from "../../PropTypes/WebsitePlanPropType";
import encodeBase64 from "../../Helpers/encodeBase64";
import { saveNormalDomainService } from "../../Services/DomainService/AddNormalDomain";
import StrikePrice from "../../Helpers/strikePrice";
import PaymentButtonBlock from ".";
import parseISODate from "../../Helpers/parseISODate";
import {
    WebsiteDetailsPropTypes,
    currentPackageOnlyPropType,
    websiteListPropType,
} from "../../PropTypes/WebsitePropTypes";
import { saveNormalWebsiteApi } from "../../Api/DomainApi/SaveNormalDomainApi";
import { DomainDetailsService } from "../../Services/DomainService/DomainDetails";
import "../../Assets/scss/components/upgradePlanList.scss";
// import "bootstrap/dist/css/bootstrap.min.css";
import TourGuide from "../TourGuide";

interface PropTypes {
    activePlanType: number; // 1-widget plan, 2- multi domain, 3 - Pre purchase
    activePlanInterval: string | null; // plan interval
    activePlanPrice: number; // active plan price
    activePlanDomain?: WebsiteDetailsPropTypes | websiteListPropType | null; // active plan domain
    forAddNewDomain?: boolean; // flag for add new domain
    newDomain?: string;
    upgradePopup?: boolean;
    forNewPurchase?: boolean;
    isDynamicPlan?: boolean;
    addNewDomain?: boolean;
}

// component to render plan/pricing list
const UpgradePlanList = (props: PropTypes) => {
    // Redux Data
    const {
        currentWebsitePlanList,
        user,
        activeLanguage,
        accessToken,
        currentUserDiscount,
        currentWebsite,
        websites,
    } = useSelector((store: StoreProptypes) => store);

    // Props
    const {
        activePlanPrice,
        activePlanInterval,
        activePlanType,
        activePlanDomain,
        forAddNewDomain,
        newDomain,
        upgradePopup,
        forNewPurchase,
        isDynamicPlan,
        addNewDomain,
    } = props;

    //console all props
   /* console.log("activePlanPrice", activePlanPrice);
    console.log("activePlanInterval", activePlanInterval);
    console.log("activePlanType", activePlanType);
    console.log("activePlanDomain", activePlanDomain);
    console.log("forAddNewDomain", forAddNewDomain);
    console.log("newDomain", newDomain);
    console.log("upgradePopup", upgradePopup);
    console.log("forNewPurchase", forNewPurchase);*/

    // Functions
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // State
    const [upgradePlanList, setUpgradePlanList] = useState<websitePlanPropType[]>(
        []
    );
    const [planInterval, setPlanInterval] = useState<string>();
    const [previousPlanInterval, setPreviousPlanInterval] = useState<string>();
    const [disabledButton, setDisabledButton] = useState<boolean>(false);
    const [freePlanID, setFreePlanID] = useState<number>();
    const [isFreeWidget, setIsFreeWidget] = useState<boolean>(false);
    const [isFreeLicense, setIsFreeLicense] = useState<boolean>(false);
    const [isExpired, setIsExpired] = useState<boolean>(false);
    const [isTrial, setIsTrial] = useState<boolean>(false);
    const [isProPlan, setIsProPlan] = useState<boolean>(false);
    const [isCanceledPlan, setIsCanceledPlan] = useState<boolean>(false);
    const [planType, setPlanType] = useState<number>(1);
    const [planPackage, setPlanPackage] = useState<currentPackageOnlyPropType>();
    const [prepurchasePackage, setPrepurchasePackage] =
        useState<currentPackageOnlyPropType>();
    const [isShowRemoveWebsitePopup, setIsShowRemoveWebsitePopup] =
        useState<boolean>(false);
    const [isPrePurchesed, setIsPrePurchesed] = useState<boolean>(false);
    const [type, setType] = useState<number>(1);
    const planTypeActive =
        currentWebsite &&
        ((currentWebsite.current_package_only?.length > 0 &&
            currentWebsite.current_package_only[0]?.platforms === "dynamic") ||
            (currentWebsite.expired_package_detail?.length > 0 &&
                currentWebsite.expired_package_detail[0]?.platforms === "dynamic") ||
            (currentWebsite.canceled_package_only?.length > 0 &&
                currentWebsite.canceled_package_only[0]?.platforms === "dynamic"))
            ? 2
            : planType;
     const dataPermission = websites?.filter((i: any) => i?.website_domain === currentWebsite?.domain)
    const paymentSettings = dataPermission && dataPermission[0]?.permissions?.find((i: any) => i?.name === "payment_allowed");
    // Disable the "Select Plan" button for users in department 1
    useEffect(() => {
        // check if admin user
        if ((user && user.department === 1) || ((user?.parent_id !== 0 &&  user?.parent_id !== 1) && paymentSettings?.name !== "payment_allowed")) {
            setDisabledButton(true);
        } else {
            setDisabledButton(false);
        }
    }, [user, paymentSettings]);


    useEffect(() => {
        if (user?.department === 2 && activePlanType && planPackage?.current_plan_type !== undefined) {
            setPlanType(planPackage?.current_plan_type === 3 ? activePlanType : planPackage?.current_plan_type);
            if (isFreeWidget) {
                setPlanType(1);
            }
        } else if (user?.department === 4 && planPackage && planPackage?.current_plan_type) {
            setPlanType(planPackage && planPackage?.current_plan_type);
            if (planPackage?.is_application_plan === 1) {
                setType(4);
            }
            if (isFreeWidget) {
                setPlanType(activePlanType);
            }
        } else {
            setPlanType(activePlanType);
        }
    }, [planPackage, activePlanType, type]);

    useEffect(() => {
        setIsFreeWidget(false);
        setIsFreeLicense(false)
        setIsExpired(false);
        setIsTrial(false);
        setIsProPlan(false);
        setIsCanceledPlan(false);
        setIsPrePurchesed(false);

        if (activePlanDomain && currentWebsite) {
            if (activePlanDomain.is_expired === 1) {
                setIsExpired(true);
            } else if (
                activePlanDomain.is_expired === 3 &&
                activePlanDomain.current_package_only.length
            ) {
                setIsTrial(true);
            } else if (
                activePlanDomain.canceled_package_only &&
                activePlanDomain.canceled_package_only.length
            ) {
                setIsCanceledPlan(true);
            } else if (
                activePlanDomain.current_package_only &&
                activePlanDomain.current_package_only.length
            ) {
                if (activePlanDomain.current_package_only[0].is_free_widget === 1) {
                    setIsFreeWidget(true);
                } else if (activePlanDomain.current_package_only[0].cancel_date) {
                    setIsCanceledPlan(true);
                } else if (activePlanDomain?.current_package_only[0]?.platforms ===  "free-license") {
                    setIsFreeLicense(true)
                } else {
                    setIsProPlan(true);
                }
            }
            if (
                activePlanDomain.pre_purchase_package_only &&
                typeof activePlanDomain.pre_purchase_package_only === "object" &&
                Object.keys(activePlanDomain.pre_purchase_package_only).length > 0
            ) {
                setIsPrePurchesed(true);
            }
        }
    }, [activePlanDomain, currentWebsite]);

    useEffect(() => {
        if (activePlanDomain) {
            if (
                activePlanDomain.expired_package_detail &&
                activePlanDomain.expired_package_detail.length
            ) {
                setPlanPackage(activePlanDomain.expired_package_detail[0]);
            } else if (
                activePlanDomain.canceled_package_only &&
                activePlanDomain.canceled_package_only.length
            ) {
                setPlanPackage(activePlanDomain.canceled_package_only[0]);
            } else if (
                activePlanDomain.current_package_only &&
                activePlanDomain.current_package_only.length
            ) {
                setPlanPackage(activePlanDomain.current_package_only[0]);
            }

            if (
                activePlanDomain.pre_purchase_package_only &&
                typeof activePlanDomain.pre_purchase_package_only === "object" &&
                Object.keys(activePlanDomain.pre_purchase_package_only).length > 0
            ) {
                setPrepurchasePackage(activePlanDomain.pre_purchase_package_only);
            }
        }
    }, [activePlanDomain]);

    // Filter the plan list based on conditions and exclude plans with is_dynamic === 1
    useEffect(() => {
        console.log(
            "currentWebsitePlanList",
            currentWebsitePlanList[`application`],
            planType,
            upgradePlanList,
            type,
            planPackage
        );

        // check if plan list available
        if (
            currentWebsitePlanList &&
            Object.keys(currentWebsitePlanList).length > 0
        ) {
            let tempPlanList: websitePlanPropType[] = [];

            // 1 = widget plan
            if (planType === 1) {
                if (type === 4) {
                    if (planPackage) {
                        // check if dynamic plan exists
                        if (planPackage.platforms === "normal-application") {
                            currentWebsitePlanList[`normal-application`]
                                .filter((planList) => planList.is_dynamic !== 1) // Exclude is_dynamic=1
                                .forEach((planList) => {
                                    if (
                                        activePlanInterval === "Y" &&
                                        planList.price >= activePlanPrice
                                    ) {
                                        tempPlanList = [...tempPlanList, planList];
                                    }
                                });

                            // check if plan list is empty
                            if (!tempPlanList.length) {
                                currentWebsitePlanList[`normal-application`]
                                    .filter((planList) => planList.is_dynamic !== 0) // Exclude is_dynamic=1
                                    .forEach((planList) => {
                                        if (activePlanInterval === "Y" &&
                                            planList.price >= activePlanPrice) {
                                            tempPlanList = [...tempPlanList, planList];
                                        }
                                    });
                            }
                        } else {
                            currentWebsitePlanList[`normal-application`]
                                .filter((planList) => planList.is_dynamic !== 1) // Exclude is_dynamic=1
                                .forEach((planList) => {
                                    if (activePlanInterval === "Y" &&
                                        planList.price >= activePlanPrice) {
                                        tempPlanList = [...tempPlanList, planList];
                                    }
                                });
                        }
                    } else {
                        currentWebsitePlanList[`normal-application`]?.map((planList) => {
                            if (activePlanInterval === "M" || activePlanInterval === null) {
                                tempPlanList = [...tempPlanList, planList];
                            } else if (activePlanInterval === "Y" &&
                                planList.price >= activePlanPrice) {
                                tempPlanList = [...tempPlanList, planList];
                            }
                        });
                    }
                } else {
                    if (planPackage) {
                        // check if dynamic plan exists
                        if (planPackage.platforms === "dynamic") {
                            currentWebsitePlanList[`dynamic`]
                                .filter((planList) => planList.is_dynamic === 1) // Exclude is_dynamic=1
                                .forEach((planList) => {
                                    if (
                                        (activePlanInterval === "M" ||
                                            activePlanInterval === null) &&
                                        planList.monthly_price >= activePlanPrice &&
                                        planList.id === planPackage.package_id
                                    ) {
                                        tempPlanList = [...tempPlanList, planList];
                                    } else if (
                                        activePlanInterval === "Y" &&
                                        planList.price >= activePlanPrice &&
                                        planList.id === planPackage.package_id
                                    ) {
                                        tempPlanList = [...tempPlanList, planList];
                                    }
                                });

                            console.log("tempPlanList: ", tempPlanList);
                            // check if plan list is empty
                            if (!tempPlanList.length) {
                                currentWebsitePlanList[`normal`]
                                    .filter((planList) => planList.is_dynamic !== 1) // Exclude is_dynamic=1
                                    .forEach((planList) => {
                                        if (
                                            (                                            activePlanInterval === "M" ||
                                                activePlanInterval === null) && planList.monthly_price >= activePlanPrice
                                        ) {
                                            tempPlanList = [...tempPlanList, planList];
                                        } else if (activePlanInterval === "Y" && planList.monthly_price >= activePlanPrice) {
                                            tempPlanList = [...tempPlanList, planList];
                                        }
                                    });
                            }
                        } else {
                            currentWebsitePlanList[`normal`]
                                .filter((planList) => planList.is_dynamic !== 1) // Exclude is_dynamic=1
                                .forEach((planList) => {
                                    if (
                                        (activePlanInterval === "M" ||
                                            activePlanInterval === null) && planList.monthly_price >= activePlanPrice
                                    ) {
                                        tempPlanList = [...tempPlanList, planList];
                                    } else if (activePlanInterval === "Y" && planList.monthly_price >= activePlanPrice) {
                                        tempPlanList = [...tempPlanList, planList];
                                    }
                                });
                        }
                    } else {
                        currentWebsitePlanList[`normal`]?.map((planList) => {
                            if ((activePlanInterval === "M" || activePlanInterval === null) && planList.monthly_price >= activePlanPrice) {
                                tempPlanList = [...tempPlanList, planList];
                            } else if (activePlanInterval === "Y" && planList.monthly_price >= activePlanPrice) {
                                tempPlanList = [...tempPlanList, planList];
                            }
                        });
                    }
                }
            }
            // check if 2- multi domain plan
            else if (planType === 2) {
                if (type === 4) {
                    if (planPackage) {
                        if (planPackage.platforms === "normal-application") {
                            currentWebsitePlanList[`normal-application`]
                                .filter((planList) => planList.is_dynamic === 1) // Exclude is_dynamic=1
                                .forEach((planList) => {
                                    if (planPackage.package_id === planList.id) {
                                        tempPlanList = [...tempPlanList, planList];
                                    }
                                });
                        } else {
                            currentWebsitePlanList[`multi-store-application`]
                                .filter((planList) => planList.is_dynamic !== 1) // Exclude is_dynamic=1
                                .forEach((planList) => {

                                    if (
                                        (activePlanInterval === "M" ||
                                            activePlanInterval === null) &&
                                        planList.monthly_price >= activePlanPrice
                                    ) {
                                        tempPlanList = [...tempPlanList, planList];
                                    } else if (
                                        activePlanInterval === "Y" &&
                                        planList.monthly_price >= activePlanPrice
                                    ) {
                                        tempPlanList = [...tempPlanList, planList];
                                    }

                                });
                        }
                    } else {
                        currentWebsitePlanList[`multi-store-application`].map((planList) => {
                            if (
                                (activePlanInterval === "M" || activePlanInterval === null) &&
                                planList.monthly_price >= activePlanPrice
                            ) {
                                tempPlanList = [...tempPlanList, planList];
                            } else if (
                                activePlanInterval === "Y" &&
                                planList.monthly_price >= activePlanPrice
                            ) {
                                tempPlanList = [...tempPlanList, planList];
                            }
                        });
                    }
                } else {
                    if (planPackage) {
                        if (planPackage.platforms === "dynamic") {
                            currentWebsitePlanList[`multi`]
                                .filter((planList) => planList.is_dynamic === 1) // Exclude is_dynamic=1
                                .forEach((planList) => {
                                    if (planPackage.package_id === planList.id) {
                                        tempPlanList = [...tempPlanList, planList];
                                    }
                                });
                        } else {
                            currentWebsitePlanList[`multi-store`]
                                .filter((planList) => planList.is_dynamic !== 1) // Exclude is_dynamic=1
                                .forEach((planList) => {

                                    if (
                                        (activePlanInterval === "M" ||
                                            activePlanInterval === null) &&
                                        planList.monthly_price >= activePlanPrice
                                    ) {
                                        tempPlanList = [...tempPlanList, planList];
                                    } else if (
                                        activePlanInterval === "Y" &&
                                        planList.monthly_price >= activePlanPrice
                                    ) {
                                        tempPlanList = [...tempPlanList, planList];
                                    }

                                });
                        }
                    } else {
                        currentWebsitePlanList[`multi-store`].map((planList) => {
                            if (
                                (activePlanInterval === "M" || activePlanInterval === null) &&
                                planList.monthly_price >= activePlanPrice
                            ) {
                                tempPlanList = [...tempPlanList, planList];
                            } else if (
                                activePlanInterval === "Y" &&
                                planList.monthly_price >= activePlanPrice
                            ) {
                                tempPlanList = [...tempPlanList, planList];
                            }
                        });
                    }
                }
            }
            // check if 3 - Pre purchase plan
            else if (planType === 3) {
                if (type === 4) {
                    if (planPackage) {
                        // check if dynamic plan exists
                        if (planPackage.platforms === "normal-application") {
                            currentWebsitePlanList[`normal-application`]
                                .filter((planList) => planList.is_dynamic !== 1) // Exclude is_dynamic=1
                                .forEach((planList) => {
                                    if (
                                        activePlanInterval === "Y" &&
                                        planList.price >= activePlanPrice
                                    ) {
                                        tempPlanList = [...tempPlanList, planList];
                                    }
                                });

                            // check if plan list is empty
                            if (!tempPlanList.length) {
                                currentWebsitePlanList[`normal-application`]
                                    .filter((planList) => planList.is_dynamic !== 0) // Exclude is_dynamic=1
                                    .forEach((planList) => {
                                        if (activePlanInterval === "Y") {
                                            tempPlanList = [...tempPlanList, planList];
                                        }
                                    });
                            }
                        } else {
                            currentWebsitePlanList[`normal-application`]
                                .filter((planList) => planList.is_dynamic !== 1) // Exclude is_dynamic=1
                                .forEach((planList) => {
                                    if (activePlanInterval === "Y") {
                                        tempPlanList = [...tempPlanList, planList];
                                    }
                                });
                        }
                    } else {
                        currentWebsitePlanList[`application`]?.map((planList) => {
                            if (activePlanInterval === "M" || activePlanInterval === null) {
                                tempPlanList = [...tempPlanList, planList];
                            } else if (activePlanInterval === "Y") {
                                tempPlanList = [...tempPlanList, planList];
                            }
                        });
                    }
                } else {
                    if (planPackage) {
                        if (planPackage?.platforms === "dynamic") {
                            currentWebsitePlanList[`dynamic`]
                                .filter((planList) => planList.is_dynamic === 1) // Exclude is_dynamic=1
                                .forEach((planList) => {
                                    if (
                                        (activePlanInterval === "M" ||
                                            activePlanInterval === null) &&
                                        planList.monthly_price >= activePlanPrice &&
                                        planList.id === planPackage.package_id
                                    ) {
                                        tempPlanList = [...tempPlanList, planList];
                                    } else if (
                                        activePlanInterval === "Y" &&
                                        planList.monthly_price >= activePlanPrice &&
                                        planList.id === planPackage.package_id
                                    ) {
                                        tempPlanList = [...tempPlanList, planList];
                                    }
                                });
                        } else {
                            // Fall back to multi plans if no eligible dynamic plans are found
                            if (!tempPlanList.length) {
                                currentWebsitePlanList[`multi`]
                                    .filter((planList) => planList.is_dynamic !== 1) // Exclude is_dynamic=1
                                    .forEach((planList) => {
                                        if (
                                            activePlanInterval === "M" &&
                                            planList.monthly_price >= activePlanPrice
                                        ) {
                                            tempPlanList = [...tempPlanList, planList];
                                        } else if (
                                            activePlanInterval === "Y" &&
                                            planList.monthly_price >= activePlanPrice
                                        ) {
                                            tempPlanList = [...tempPlanList, planList];
                                        }
                                    });
                            }
                        }
                    } else {
                        currentWebsitePlanList[`multi`]
                            .filter((planList) => planList.is_dynamic !== 1) // Exclude is_dynamic=1
                            .forEach((planList) => {
                                if (
                                    activePlanInterval === "M" &&
                                    planList.monthly_price >= activePlanPrice
                                ) {
                                    tempPlanList = [...tempPlanList, planList];
                                } else if (
                                    activePlanInterval === "Y" &&
                                    planList.price >= activePlanPrice
                                ) {
                                    tempPlanList = [...tempPlanList, planList];
                                }
                            });
                    }
                }
            }
            console.log("tempPlanList: ", tempPlanList);
            setUpgradePlanList(tempPlanList);
        }
    }, [
        planType,
        activePlanInterval,
        activePlanPrice,
        planPackage,
        activePlanType,
        type,
    ]);

    useEffect(() => {
        if (type === 4) {
            setPlanInterval("Y");
        } else if (activePlanInterval) {
            setPlanInterval(activePlanInterval);
            setPreviousPlanInterval(activePlanInterval);
        } else {
            setPlanInterval("M");
            setPreviousPlanInterval("M");
        }
    }, [activePlanInterval, type]);

    // Retrieve the ID of the free widget plan
    useEffect(() => {
        if (currentWebsitePlanList && currentWebsitePlanList["free-widget"]) {
            setFreePlanID(currentWebsitePlanList["free-widget"][0].id);
        }
    }, [currentWebsitePlanList]);

    // Handle widget plan purchase
    const handlePurchaseWidgetPlan = (
        planID: number,
        isTrial: boolean,
        isDownGradePlan: boolean
    ) => {
        // API to save normal website
        /*  console.log("activePlanDomain handlePurchaseWidgetPlan", activePlanDomain);
             console.log("newDomain handlePurchaseWidgetPlan", newDomain);
             console.log("planPackage handlePurchaseWidgetPlan", planPackage); */
        if (accessToken && user && activeLanguage && planID) {
            let iframeURLType: number;
            if (forAddNewDomain && !isDownGradePlan) {
                iframeURLType = 1;
            } else if (
                planPackage &&
                planPackage.package_id === planID &&
                planPackage.subscr_interval === planInterval &&
                !isDownGradePlan
            ) {
                if (
                    activePlanDomain &&
                    ((activePlanDomain.used_canceled_discount === 1 && isCanceledPlan) ||
                        !activePlanDomain.is_from_dashboard ||
                        isExpired)
                ) {
                    iframeURLType = 1; // reactivate plan for widget user without discount
                } else {
                    iframeURLType = 10; // reactivate plan for widget user with discount
                }
            } else if (
                isDownGradePlan &&
                activePlanDomain &&
                !activePlanDomain.is_from_dashboard === false
            ) {
                if (
                    activePlanDomain &&
                    activePlanDomain.used_canceled_discount === 1 &&
                    isCanceledPlan
                ) {
                    iframeURLType = 62;
                } else {
                    iframeURLType = 60;
                }
            } else {
                iframeURLType = 1; // reactivate plan for widget user without discount
            }
            const navigateToPurchase = () => {
                let domain = "";
                if (newDomain) {
                    domain = newDomain;
                } else if (activePlanDomain) {
                    domain = activePlanDomain.domain;
                }
                console.log("domain", domain);
                const urlString = `${planID}|${domain}|${planInterval}|${user?.parent_id === 0 || user?.parent_id === 1 ? user?.id : user?.parent_id}|${
                    activeLanguage.code
                }|${iframeURLType}${isTrial ? "||1" : ""}`;
                const encodedString = encodeBase64(urlString);
                navigate(`/front/package/${encodedString}${user?.parent_id === 0 || user?.parent_id === 1 ? "" : `?subUserId=${user?.id}`}`);
            };

            if (forAddNewDomain && newDomain) {
                saveNormalWebsiteApi(accessToken, newDomain, user.id, planID).then(
                    (res) => {
                        // check if response data is available
                        console.log(`test: saveNormalWebsiteApi response`, res);
                        if (res.Data) {
                            navigateToPurchase();
                        }
                    }
                );
            } else {
                navigateToPurchase();
            }
        }

        /* if (user && activeLanguage && planID) {
                const urlString = `${planID}|${activePlanDomain}|${planInterval}|${user.id}|${activeLanguage.code}|1${isTrial ? "||1" : ""}`;
                const encodedString = encodeBase64(urlString);
                navigate(`/front/package/${encodedString}`);
            } */
    };

    // Widget multi-store Plan Purchase Event
    // Widget multi-store Plan Purchase Event
    const handleMultiStoreWidgetPlan = (planID: number) => {
        if (user && activeLanguage && planID && activePlanDomain && planPackage) {
            if (currentWebsite?.domain !== activePlanDomain.domain && accessToken) {
                DomainDetailsService(accessToken, activePlanDomain.id, dispatch);
            }
            console.log(`planPackage.package_id`, planPackage.package_id);
            console.log(`planID`, planID);
            let iframeURLType: number;
            if (forNewPurchase) {
                iframeURLType = 5; // purchase a new plan for multi site partner user
            } else if (
                planPackage.package_id === planID &&
                planPackage.subscr_interval === planInterval
            ) {
                if (
                    (activePlanDomain.used_canceled_discount === 1 && isCanceledPlan) ||
                    !activePlanDomain.is_from_dashboard ||
                    isExpired
                ) {
                    iframeURLType = 52; // reactivate plan for multi site partner user without discount
                } else {
                    iframeURLType = 51; // reactivate plan for multi site partner user with discount
                }
            } else {
                iframeURLType = 52; // reactivate plan for multi site partner user with discount
            }
            const urlString = `${planID}|${`multi-store`}|${planInterval}|${user?.parent_id === 0 || user?.parent_id === 1 ?
                user.id : user?.parent_id
            }|${activeLanguage.code}|${iframeURLType}`;
            const encodedString = encodeBase64(urlString);
            navigate(`/front/package/${encodedString}${user?.parent_id === 0 || user?.parent_id === 1 ? "" : `?subUserId=${user?.id}`}`);
        }
    };

    // Handle multi-domain widget plan purchase
    const handleMultiDomainWidgetPlan = (planID: number) => {
        if (user && activeLanguage && planID) {
            const urlString = `${planID}|${`multi`}|${planInterval}|${user?.parent_id === 0 || user?.parent_id === 1 ? user?.id : user?.parent_id}|${
                activeLanguage.code
            }|3`;
            const encodedString = encodeBase64(urlString);
            navigate(`/front/package/${encodedString}${user?.parent_id === 0 || user?.parent_id === 1 ? "" : `?subUserId=${user?.id}`}`);
        }
    };

    // Handle purchase of a normal domain plan for adding a new domain
    const handlePurchaseNormalDomainPlan = (planID: number) => {
        //console.log("test: handlePurchaseNormalDomainPlan is called");
        let domain = "";
        if (newDomain) {
            domain = newDomain;
        } else if (activePlanDomain) {
            domain = activePlanDomain.domain;
        }
        //console.log("domain", domain);
        if (
            accessToken &&
            user &&
            planID &&
            activeLanguage &&
            planInterval &&
            domain
        ) {
            saveNormalDomainService(
                accessToken,
                domain,
                user.id,
                planID,
                planInterval,
                activeLanguage.code,
                planID === freePlanID,
                dispatch,
                navigate,
                t,
                user?.parent_id
            );
        }
    };

    const handlePurchase = (planID: number) => {
        //console.log("handlePurchase plan id", planID);
        var isDownGradePlan: boolean = false;
        const getDomainPrice = upgradePlanList.find((d) => d.id === planID);
        if (getDomainPrice) {
            if (getDomainPrice.monthly_price <= activePlanPrice) {
                isDownGradePlan = true;
            }
        }

        switch (planType) {
            case 1:
                handlePurchaseWidgetPlan(planID, false, false);
                break;
            case 2:
                handleMultiStoreWidgetPlan(planID);
                break;
            case 3:
                if (activePlanPrice === 0) {
                    handleMultiDomainWidgetPlan(planID);
                } else {
                    handleMultiStoreWidgetPlan(planID);
                }
                break;
            default:
        }
    };
    // useEffect(() => {
    //     if (planPackage && activePlanInterval) {
    //         if (
    //             activePlanInterval === "M" &&
    //             (planPackage.slug === "large-site-10-domains" ||
    //                 planPackage.slug === "extra-large-site" ||
    //                 planPackage.slug === "platinum")
    //         ) {
    //             setPlanInterval("Y");
    //         }
    //     }
    // }, [planPackage, activePlanInterval]);
    useEffect(() => {
        if (planPackage && activePlanInterval) {
            setPlanInterval(activePlanInterval);
        }
    }, [planPackage, activePlanInterval]);

    const transformValue = (value: number): number => {
        return Math.floor(value / 10);
    };

    const setRemoveWebsitePopup = () => {
        setIsShowRemoveWebsitePopup(false);
    };

    const formattedNextDate = (id: number) => {
        if (prepurchasePackage && prepurchasePackage.package_id === id) {
            const nextDate = prepurchasePackage.start_date;
            return nextDate;
        }
    };

    return (
        <>
            <TourGuide />
            {console.log("isCanceledPlan", isCanceledPlan)}
            {console.log("isExpired", isExpired)}
            {console.log("upgradePlanList", upgradePlanList)}
            {console.log("plan app", type)}

            <div className="aioa_dashboard-widget-plan-list tour-manageplan-select">
                {(!user?.website_lists.length || addNewDomain) &&
                user?.department === 4 ? (
                    <Container className="mt-4 w-100 d-flex justify-content-center mobile-small-text">
                        <Tabs
                            id="plan-tabs"
                            activeKey={type?.toString()}
                            onSelect={(k) => setType(Number(k))}
                            className="mb-3 custom-tabs m-0"
                            justify
                        >
                            <Tab
                                eventKey="1"
                                title="Plan by page views"
                                tabClassName="view-tab"
                            ></Tab>

                            <Tab
                                eventKey="4"
                                title="Plan by application users"
                                tabClassName="user-tab"
                            ></Tab>
                        </Tabs>
                    </Container>
                ) : (
                    ""
                )}
                <div
                    className={
                        true
                            ? `time-plan d-flex justify-content-between align-items-center ${type === 4 ? "mb-4" : ""}`
                            : ""
                    }
                >
                    {!user?.website_lists.length || addNewDomain ? (
                        <div className="d-flex">
                            <Button
                                variant="link"
                                className={`${
                                    planType === 1 ? "text-primary" : "text-secondary"
                                } me-2`}
                                onClick={() => setPlanType(1)}
                            >
                                {t("Single Site Plans")}
                            </Button>
                            |
                            <Button
                                variant="link"
                                className={`${
                                    planType === 2 ? "text-primary" : "text-secondary"
                                } ms-2`}
                                onClick={() => setPlanType(2)}
                            >
                                {t("Multisite Plans")}
                            </Button>
                        </div>
                    ) : (
                        ""
                    )}
                    {type !== 4 && (
                        <>
                            {(forNewPurchase ||
                                activePlanInterval === "M" ||
                                activePlanInterval === null || isFreeWidget) &&
                            !((planPackage?.slug === "large-site-10-domains" ||
                                    planPackage?.slug === "extra-large-site" ||
                                    planPackage?.slug === "platinum") &&
                                activePlanInterval === "Y"
                            ) && (
                                <>
                                    <div
                                        className={`aioa_dashboard-plan-list-toggle ${
                                            forAddNewDomain ? "justify-content-center" : ""
                                        }`}
                                    >
                                        <span
                                            className={`toggle-label monthly ${
                                                planInterval === "M" ? `active` : ``
                                            }`}
                                            role="button"
                                            onClick={() => setPlanInterval("M")}
                                        >
                                            {t("Pay Monthly")}
                                        </span>
                                        <Form.Check // prettier-ignore
                                            type="switch"
                                            id="custom-switch"
                                            aria-label="Toggle Annual Plan"
                                            defaultChecked={false}
                                            checked={planInterval === "Y"}
                                            onChange={() =>
                                                setPlanInterval(planInterval === "M" ? "Y" : "M")
                                            }
                                        />
                                        <span
                                            className={`toggle-label annually ${
                                                planInterval === "Y" ? `active` : ``
                                            }`}
                                            role="button"
                                            onClick={() => setPlanInterval("Y")}
                                        >
                        {t("Pay Annually")}
                                            <span className="discount">
                          Save 20%
                                                {/* {t("Save",{percentage: `20%`})} */}
                        </span>
                      </span>
                                        {/* <ul>
                                        <li><Button className={`${planInterval === 'M' ? `active` : ``}`} variant={`${planInterval === 'M' ? `primary` : `secondary`}`} onClick={() => setPlanInterval('M')}>{t('Pay Monthly')}</Button></li>
                                        <li><Button className={`${planInterval === 'Y' ? `active` : ``}`} variant={`${planInterval === 'Y' ? `primary` : `secondary`}`} onClick={() => setPlanInterval('Y')}>{t('Pay Yearly')}</Button></li>
                                    </ul> */}
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>
               
                <Row
                    className="gx-2 gy-4"
                    xs={1}
                    md={12}
                    xl={upgradePlanList && upgradePlanList.length < 0 ? 12:
                        (forAddNewDomain && user && user.department !== 4
                            ? upgradePlanList.length + 1 < 4
                                ? 4
                                : upgradePlanList.length + 1
                            : upgradePlanList.length < 4
                                ? (isFreeWidget || isFreeLicense)
                                    ? 5
                                    : 4
                                : (isFreeWidget || isFreeLicense)
                                    ? upgradePlanList.length + 1
                                    : upgradePlanList.length)
                    }
                    // xl={12}
                >
                    {upgradePlanList && upgradePlanList.length > 0 ? (
                        <>
                            {forAddNewDomain &&
                            user &&
                            user.department !== 4 &&
                            !!isDynamicPlan &&
                            planType !== 2 ? (
                                <Col>
                                    <Card className="aioa_dashboard-widget-plan-box">
                                        <Card.Header className="h5">
                                            <div className="aioa_dashboard-widget-plan-box-name">
                                                <span>{t("Free Widget")}</span>
                                            </div>
                                            <div className="aioa_dashboard-widget-plan-box-price">
                                                <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                    $0
                                                    <span>
                            /
                                                        {planInterval === "M"
                                                            ? t("Per Month")
                                                            : t("Per Year")}
                          </span>
                                                </div>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <div className="aioa_dashboard-widget-plan-box-description-wrapper">
                                                <div className="aioa_dashboard-widget-plan-box-description">
                                                    {t("Plan Description Text", { pageViews: 10 })}
                                                </div>
                                            </div>

                                            <div className="aioa_dashboard-widget-plan-box-btn">
                                                {freePlanID ? (
                                                    <Button
                                                        variant="primary"
                                                        size="lg"
                                                        className="w-100"
                                                        onClick={() =>
                                                            handlePurchaseNormalDomainPlan(freePlanID)
                                                        }
                                                    >
                                                        {t("Select Plan")}
                                                    </Button>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            {currentWebsite === null ? (
                                                <>
                                                    <div className="pt-3 mt-3 border-top text-center invisible">
                                                        <a
                                                            role="button"
                                                            className={`${disabledButton ? `pe-none` : ``}`}
                                                            aria-disabled={`${
                                                                disabledButton ? `true` : `false`
                                                            }`}
                                                            tabIndex={disabledButton ? -1 : 0}
                                                        >
                                                            {t("free trial btn label")}
                                                        </a>
                                                    </div>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ) : (
                                <></>
                            )}

                            {!forAddNewDomain && isFreeWidget && !upgradePopup ? (
                                <Col>
                                    <Card className="aioa_dashboard-widget-plan-box current">
                                        <Card.Header className="h5">
                                            <div className="aioa_dashboard-widget-plan-box-name">
                                                <span>{t("Free Widget")}</span>
                                                <div className="status active">{t("Active")}</div>
                                            </div>
                                            <div className="aioa_dashboard-widget-plan-box-price">
                                                <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                    $0
                                                    <span>
                            /
                                                        {planInterval === "M"
                                                            ? t("Per Month")
                                                            : t("Per Year")}
                          </span>
                                                </div>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <div className="aioa_dashboard-widget-plan-box-description-wrapper">
                                                {/* <div className="aioa_dashboard-widget-plan-box-description">
                                                    {t("Plan Description Text", { pageViews: 10 })}
                                                </div> */}
                                            </div>

                                            <div className="aioa_dashboard-widget-plan-box-btn">
                        <span className="btn btn-lg btn-warning w-100 pe-none">
                          {t("Current Plan")}
                        </span>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ) : !forAddNewDomain && isFreeLicense && !upgradePopup ? (
                                <Col>
                                    <Card className="aioa_dashboard-widget-plan-box current">
                                        <Card.Header className="h5">
                                            <div className="aioa_dashboard-widget-plan-box-name">
                                                <span>{t("Free License")}</span>
                                                <div className="status active">{t("Active")}</div>
                                            </div>
                                            <div className="aioa_dashboard-widget-plan-box-price">
                                                <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                    $0
                                                    <span>
                            /
                                                        {planInterval === "M"
                                                            ? t("Per Month")
                                                            : t("Per Year")}
                          </span>
                                                </div>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <div className="aioa_dashboard-widget-plan-box-description-wrapper">
                                                <div className="aioa_dashboard-widget-plan-box-description">
                                                    {t("Plan Description Text", { pageViews: 10 })}
                                                </div>
                                            </div>

                                            <div className="aioa_dashboard-widget-plan-box-btn">
                        <span className="btn btn-lg btn-warning w-100 pe-none">
                          {t("Current Plan")}
                        </span>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ) : (<></>)}

                            {!isFreeLicense && activePlanDomain &&
                            upgradePlanList.map((planItem) => {
                                return (
                                    <Col
                                        key={planItem.id}
                                        className={`${
                                            planInterval === activePlanInterval &&
                                            planItem.monthly_price === activePlanPrice &&
                                            upgradePopup
                                                ? "d-none"
                                                : ""
                                        }`}
                                    >
                                        <Card
                                            className={`aioa_dashboard-widget-plan-box 
                                        ${
                                                (isProPlan || isTrial) &&
                                                planInterval === activePlanInterval &&
                                                planItem.monthly_price ===
                                                activePlanPrice
                                                    ? "active"
                                                    : ""
                                            } 
                                        ${
                                                planInterval === activePlanInterval &&
                                                planItem.monthly_price ===
                                                activePlanPrice
                                                    ? "current"
                                                    : ""
                                            }`}
                                        >
                                            <Card.Header className="h5">
                                                <div className="aioa_dashboard-widget-plan-box-name">
                                                    <span>{planItem.name}</span>
                                                    {isProPlan && (
                                                        <div className="status active">{t("Active")}</div>
                                                    )}
                                                    {isTrial && (
                                                        <div className="status trial">{t("trial")}</div>
                                                    )}
                                                    {isCanceledPlan && (
                                                        <div className="status cancelled">
                                                            {t("Cancelled")}
                                                        </div>
                                                    )}
                                                    {isExpired && (
                                                        <div className="status expired">
                                                            {t("Expired")}
                                                        </div>
                                                    )}
                                                </div>
                                                
                                                <div className="aioa_dashboard-widget-plan-box-price">
                                                    {user &&
                                                    user.department === 4 &&
                                                    currentUserDiscount &&
                                                    currentUserDiscount.discount_value > 0 && planPackage ? (
                                                        <>
                                                        {planInterval ===
                                                                                                activePlanInterval &&
                                                                                                planItem.monthly_price ===
                                                                                                activePlanPrice &&
                                                                                                planPackage  ? <>
                                                        
                                                             {planInterval === "M" ? (
                                                                <>
                                                                    <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                                        <del className="me-2">
                                                                            <small>
                                                                                  {!isExpired && planPackage?.package_monthly_price < planPackage?.final_price ? <>
                                                                                  ${(Number(planPackage.package_monthly_price) + Number(planPackage.discount_price)).toFixed()} </> : <>
                                                                               ${Number(planPackage.package_monthly_price)}
                                                                                </>}
                                                                            </small>
                                                                        </del>
                                                                         {!isExpired && planPackage?.package_monthly_price < planPackage?.final_price ? <>
                                                                                                        $
                                                                                                {planPackage?.final_price.toFixed(
                                                                                                            2
                                                                                                        )}
                                                                                                </> : <>
                                                                                                     $
                                                                                                <StrikePrice price={planPackage?.package_monthly_price}/>
                                                                        </>}
                                                                        <span>/{t("Per Month")}</span>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                                        <del className="me-2">
                                                                            <small>
                                                                                  {!isExpired && planPackage?.package_price < planPackage?.final_price ? <>
                                                                                 ${(Number(planPackage.price) + Number(planPackage.discount_price)).toFixed()} </> : <>
                                                                                ${Number(planPackage.package_price)}
                                                                                </>}
                                                                                {/* ${planPackage.price.toFixed(2)} */}
                                                                            </small>
                                                                        </del>
                                                                          {!isExpired && planPackage?.package_price < planPackage?.final_price ? <>
                                                                                                        $
                                                                                                {planPackage?.final_price.toFixed(
                                                                                                            2
                                                                                                        )}
                                                                                                </> : <>

                                                                                                $<StrikePrice
                                                                            price={planPackage?.package_price}
                                                                        />
                                                                                                     {/* $
                                                                                                {planPackage?.package_price.toFixed(
                                                                                                    2
                                                                                                )} */}
                                                                        </>}
                                                                        <span>/{t("Per Year")}</span>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </> 
                                                        :
                                                        <>
                                                              {planInterval === "M" ? (
                                                                <>
                                                                    <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                                        <del className="me-2">
                                                                            <small>
                                                                                ${planItem.monthly_price.toFixed(2)}
                                                                            </small>
                                                                        </del>
                                                                        $
                                                                        <StrikePrice
                                                                            price={planItem.monthly_price}
                                                                        />
                                                                        <span>/{t("Per Month")}</span>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                                        <del className="me-2">
                                                                            <small>
                                                                                ${planItem.price.toFixed(2)}
                                                                            </small>
                                                                        </del>
                                                                        $<StrikePrice price={planItem.price} />
                                                                        <span>/{t("Per Year")}</span>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </>
                                                        }
                                                        </>
                                                    ) : (
                                                        <>
                                                            {planInterval === "M" ? (
                                                                <>
                                                                    <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                                        {activePlanDomain ? (
                                                                            <>
                                                                                {" "}
                                                                                {isCanceledPlan ? (
                                                                                    <>
                                                                                        {activePlanDomain.used_canceled_discount ===
                                                                                        0 &&
                                                                                        !isFreeWidget &&
                                                                                        activePlanDomain.canceled_package_only &&
                                                                                        activePlanDomain
                                                                                            .canceled_package_only.length &&
                                                                                        activePlanDomain.is_from_dashboard ? (
                                                                                            <>
                                                                                                {planInterval ===
                                                                                                activePlanInterval &&
                                                                                                planItem.monthly_price ===
                                                                                                activePlanPrice &&
                                                                                                planPackage ? (
                                                                                                    <>
                                                                                                        <del className="me-2">
                                                                                                            <small>
                                                                                                                $
                                                                                                                {planItem.monthly_price.toFixed(
                                                                                                                    2
                                                                                                                )}
                                                                                                            </small>
                                                                                                        </del>
                                                                                                        {activePlanDomain.is_cancel_offer_accept ===
                                                                                                        1 ? (
                                                                                                            <>
                                                                                                                $
                                                                                                                <StrikePrice
                                                                                                                    price={
                                                                                                                        planItem.monthly_price
                                                                                                                    }
                                                                                                                    isDiscountPr={true}
                                                                                                                    discountPr={
                                                                                                                        activePlanDomain.cancel_discount_percentage
                                                                                                                    }
                                                                                                                />
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                $
                                                                                                                <StrikePrice
                                                                                                                    price={
                                                                                                                        planItem.monthly_price
                                                                                                                    }
                                                                                                                    isDiscountPr={true}
                                                                                                                    discountPr={
                                                                                                                        activePlanDomain.reactivate_discount
                                                                                                                    }
                                                                                                                />
                                                                                                            </>
                                                                                                        )}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        $
                                                                                                        <StrikePrice
                                                                                                            price={
                                                                                                                planItem.monthly_price
                                                                                                            }
                                                                                                        />
                                                                                                    </>
                                                                                                )}
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                {planInterval ===
                                                                                                activePlanInterval &&
                                                                                                planItem.monthly_price ===
                                                                                                activePlanPrice &&
                                                                                                planPackage ? (
                                                                                                    <>
                                                                                                   {!isExpired && planPackage?.package_monthly_price < planPackage?.final_price ? <>
                                                                                                        $
                                                                                                {planPackage?.final_price.toFixed(
                                                                                                            2
                                                                                                        )}
                                                                                                </> : <>
                                                                                                     $
            
                                                                                                {planPackage?.coupon_id > 0 || planPackage?.discount_price > 0 ?  planPackage.final_price.toFixed(
                                                                                                    2
                                                                                                ) : planPackage?.package_monthly_price.toFixed(
                                                                                                    2
                                                                                                )}
                                                                                                </>}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        $
                                                                                                        {planItem.monthly_price.toFixed(
                                                                                                            2
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        {planInterval ===
                                                                                        activePlanInterval &&
                                                                                        planItem.monthly_price ===
                                                                                        activePlanPrice &&
                                                                                        planPackage ? (
                                                                                            <>{!isExpired && planPackage?.package_monthly_price < planPackage?.final_price ? <>
                                                                                                $
                                                                                                {planPackage.final_price.toFixed(
                                                                                                    2
                                                                                                )}
                                                                                                </> : <>
                                                                                                     $
                                                                                                {planPackage?.coupon_id > 0 || planPackage?.discount_price > 0 ?  planPackage.final_price.toFixed(
                                                                                                    2
                                                                                                ) :planPackage.package_monthly_price.toFixed(
                                                                                                    2
                                                                                                )}
                                                                                                </>}
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                $
                                                                                                {planItem.monthly_price.toFixed(
                                                                                                    2
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <></>
                                                                        )}
                                                                        <span>/{t("Per Month")}</span>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                                        {activePlanDomain ? (
                                                                            <>
                                                                                {" "}
                                                                                {isCanceledPlan ? (
                                                                                    <>
                                                                                        {activePlanDomain.used_canceled_discount ===
                                                                                        0 &&
                                                                                        !isFreeWidget &&
                                                                                        activePlanDomain.canceled_package_only &&
                                                                                        activePlanDomain
                                                                                            .canceled_package_only.length &&
                                                                                        activePlanDomain.is_from_dashboard ? (
                                                                                            <>
                                                                                                {planInterval ===
                                                                                                activePlanInterval &&
                                                                                                planItem.monthly_price ===
                                                                                                activePlanPrice &&
                                                                                                planPackage ? (
                                                                                                    <>
                                                                                                        <del className="me-2">
                                                                                                            <small>
                                                                                                                $
                                                                                                                {planItem.price.toFixed(
                                                                                                                    2
                                                                                                                )}
                                                                                                            </small>
                                                                                                        </del>
                                                                                                        {activePlanDomain.is_cancel_offer_accept ===
                                                                                                        1 ? (
                                                                                                            <>
                                                                                                                $
                                                                                                                <StrikePrice
                                                                                                                    price={
                                                                                                                        planItem.price
                                                                                                                    }
                                                                                                                    isDiscountPr={true}
                                                                                                                    discountPr={
                                                                                                                        activePlanDomain.cancel_discount_percentage
                                                                                                                    }
                                                                                                                />
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                $
                                                                                                                <StrikePrice
                                                                                                                    price={
                                                                                                                        planItem.price
                                                                                                                    }
                                                                                                                    isDiscountPr={true}
                                                                                                                    discountPr={
                                                                                                                        activePlanDomain.reactivate_discount
                                                                                                                    }
                                                                                                                />
                                                                                                            </>
                                                                                                        )}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        $
                                                                                                        <StrikePrice
                                                                                                            price={planItem.price}
                                                                                                        />
                                                                                                    </>
                                                                                                )}
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                {planInterval ===
                                                                                                activePlanInterval &&
                                                                                                planItem.monthly_price ===
                                                                                                activePlanPrice &&
                                                                                                planPackage ? (
                                                                                                    <>
                                                                                                     {!isExpired && planPackage?.package_price < planPackage?.final_price ? <>
                                                                                                        $
                                                                                                        {planPackage.final_price.toFixed(
                                                                                                            2
                                                                                                        )}
                                                                                                </> : <>
                                                                                                     $
                                                                                              {planPackage?.coupon_id > 0 || planPackage?.discount_price > 0 ?  planPackage.final_price.toFixed(
                                                                                                    2
                                                                                                ) : planPackage.package_price.toFixed(
                                                                                                    2
                                                                                                )}
                                                                                                </>}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        $
                                                                                                        {planItem.price.toFixed(
                                                                                                            2
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        {planInterval ===
                                                                                        activePlanInterval &&
                                                                                        planItem.monthly_price ===
                                                                                        activePlanPrice &&
                                                                                        planPackage ? (
                                                                                            <>
                                                                                               {!isExpired && planPackage?.package_price < planPackage?.final_price ? <>
                                                                                                $
                                                                                                {planPackage.final_price.toFixed(
                                                                                                    2
                                                                                                )}
                                                                                                </> : <>
                                                                                                     $
                                                                                                {planPackage?.coupon_id > 0 || planPackage?.discount_price > 0 ?  planPackage.final_price.toFixed(
                                                                                                    2
                                                                                                ) : planPackage.package_price.toFixed(
                                                                                                    2
                                                                                                )}
                                                                                                </>}
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                ${planItem.price.toFixed(2)}
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <></>
                                                                        )}
                                                                        <span>/{t("Per Year")}</span>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                                {(isProPlan || isTrial) &&
                                                planPackage &&
                                                planPackage.subscr_interval === planInterval &&
                                                planItem.monthly_price === activePlanPrice ? (
                                                    <>
                                                        <div className="aioa_dashboard-widget-plan-box-renewal-badge">
                                                            {/* {t("Next Renewal on", { date: parseISODate(planPackage.end_date) })} */}
                                                            Next Renewal on{" "}
                                                            {parseISODate(planPackage.end_date)}
                                                        </div>
                                                        <div className="aioa_dashboard-widget-plan-box-divider"></div>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}

                                                {transformValue(planItem.monthly_price) <
                                                activePlanPrice &&
                                                isPrePurchesed &&
                                                planPackage &&
                                                planPackage.subscr_interval === planInterval ? (
                                                    <>
                                                        {formattedNextDate(planItem.id) && (
                                                            <div className="aioa_dashboard-widget-plan-box-renewal-badge">
                                                                Next Active on{" "}
                                                                {parseISODate(
                                                                    formattedNextDate(planItem.id)!
                                                                )}
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <></>
                                                )}

                                                {isCanceledPlan &&
                                                activePlanDomain?.canceled_package_only.length &&
                                                planPackage &&
                                                planPackage.subscr_interval === planInterval &&
                                                planItem.monthly_price === activePlanPrice ? (
                                                    <>
                                                        <div className="aioa_dashboard-widget-plan-box-renewal-badge">
                                                            {/* {t("Cancelled on", { date: parseISODate(planPackage.cancel_date) })} */}
                                                            Cancelled on{" "}
                                                            {parseISODate(planPackage.cancel_date)}
                                                        </div>
                                                        <div className="aioa_dashboard-widget-plan-box-divider"></div>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                            </Card.Header>
                                            <Card.Body>
                                                <div className="aioa_dashboard-widget-plan-box-description-wrapper">
                                                    <div className="aioa_dashboard-widget-plan-box-description">
                                                        {t("Plan Description Text", {
                                                            pageViews: planItem.page_views,
                                                        })}
                                                    </div>

                                                    {planType === 2 && (
                                                        <>
                                                            <div className="aioa_dashboard-widget-plan-domain-description">
                                                                {t("plan domain info", {
                                                                    domainCount:
                                                                        planItem.slug === "silver"
                                                                            ? 3
                                                                            : planItem.slug === "gold"
                                                                            ? 5
                                                                            : planItem.domain_limit
                                                                                ? planItem.domain_limit
                                                                                : 10,
                                                                })}
                                                            </div>
                                                        </>
                                                    )}

                                                    {planType === 3 && (
                                                        <>
                                                            <div className="aioa_dashboard-widget-plan-domain-description">
                                                                {t("plan domain info", {
                                                                    domainCount: planItem.domain_limit || 0,
                                                                })}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>

                                                <div className="aioa_dashboard-widget-plan-box-btn">
                                                    {forAddNewDomain ? (
                                                        <>
                                                            {planType === planTypeActive ? (
                                                                <>
                                                                    <Button
                                                                        variant="primary"
                                                                        size="lg"
                                                                        className="w-100"
                                                                        onClick={() =>
                                                                            handlePurchaseNormalDomainPlan(
                                                                                planItem.id
                                                                            )
                                                                        }
                                                                        disabled={disabledButton}
                                                                    >
                                                                        {t("Select Plan")}
                                                                    </Button>
                                                                    {user?.department === 4 ? (
                                                                        <>
                                                                            <div className="pt-3 mt-3 border-top text-center">
                                                                                <a
                                                                                    role="button"
                                                                                    onClick={() =>
                                                                                        handlePurchaseWidgetPlan(
                                                                                            planItem.id,
                                                                                            true,
                                                                                            false
                                                                                        )
                                                                                    }
                                                                                    className={`${
                                                                                        disabledButton ? `pe-none` : ``
                                                                                    }`}
                                                                                    aria-disabled={`${
                                                                                        disabledButton ? `true` : `false`
                                                                                    }`}
                                                                                    tabIndex={disabledButton ? -1 : 0}
                                                                                >
                                                                                    {t("free trial btn label")}
                                                                                </a>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {activePlanDomain &&
                                                            planPackage &&
                                                            planPackage.subscr_interval === planInterval &&
                                                            planItem.monthly_price === activePlanPrice &&
                                                            planPackage ? (
                                                                <>
                                                                    {isCanceledPlan && (
                                                                        <>
                                                                            {activePlanDomain.canceled_package_only &&
                                                                            activePlanDomain.canceled_package_only
                                                                                .length > 0 ? (
                                                                                <>
                                                                                    <Button
                                                                                        variant="primary"
                                                                                        size="lg"
                                                                                        className="w-100"
                                                                                        onClick={() => {
                                                                                            handlePurchase(planItem.id);
                                                                                        }}
                                                                                        disabled={disabledButton}
                                                                                    >
                                                                                        {t("Reactivate Now")}
                                                                                    </Button>
                                                                                </>
                                                                            ) : (
                                                                                <span className="btn btn-lg btn-danger w-100 pe-none">
                                            Expires on{" "}
                                                                                    {parseISODate(planPackage.end_date)}
                                                                                    {/* {t("Expires on", { date: parseISODate(planPackage.end_date) })} */}
                                          </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {isExpired && (
                                                                        <Button
                                                                            variant="primary"
                                                                            size="lg"
                                                                            className="w-100"
                                                                            onClick={() => {
                                                                                handlePurchase(planItem.id);
                                                                            }}
                                                                            disabled={disabledButton}
                                                                        >
                                                                            {t("Renew Now")}
                                                                        </Button>
                                                                    )}
                                                                    {isProPlan && (
                                                                        <PaymentButtonBlock
                                                                            buttonType={3}
                                                                            activePlanType={activePlanType}
                                                                            activePlanDomain={activePlanDomain}
                                                                            activePlanInterval={
                                                                                planPackage.subscr_interval
                                                                            }
                                                                            activePlanPrice={
                                                                                planPackage.final_price
                                                                            }
                                                                            activePlanOfferPrice={
                                                                                activePlanDomain.cancel_discount_price
                                                                            }
                                                                            activePlanOfferPr={
                                                                                activePlanDomain.cancel_discount_percentage
                                                                            }
                                                                            websiteID={activePlanDomain.id}
                                                                            activeUserID={activePlanDomain.user_id}
                                                                            activePlanID={planPackage.package_id}
                                                                            buttonBigSize={true}
                                                                            buttonVariant={`danger`}
                                                                            buttonLabel={`Cancel Plan`}
                                                                            isShowDiscount={false}
                                                                        />
                                                                    )}

                                                                    {isTrial && (
                                                                        <>
                                                                            <PaymentButtonBlock
                                                                                buttonType={3}
                                                                                activePlanType={planType}
                                                                                activePlanDomain={activePlanDomain}
                                                                                activePlanInterval={
                                                                                    planPackage.subscr_interval
                                                                                }
                                                                                activePlanPrice={
                                                                                    planPackage.final_price
                                                                                }
                                                                                activePlanOfferPrice={
                                                                                    activePlanDomain.cancel_discount_price
                                                                                }
                                                                                activePlanOfferPr={
                                                                                    activePlanDomain.cancel_discount_percentage
                                                                                }
                                                                                websiteID={activePlanDomain.id}
                                                                                activeUserID={
                                                                                    activePlanDomain.user_id
                                                                                }
                                                                                activePlanID={planPackage.package_id}
                                                                                buttonBigSize={true}
                                                                                buttonVariant={`danger`}
                                                                                buttonLabel={`Cancel Plan`}
                                                                                isShowDiscount={
                                                                                    user &&
                                                                                    user.department !== 4 &&
                                                                                    activePlanDomain &&
                                                                                    activePlanDomain.current_package_only &&
                                                                                    activePlanInterval &&
                                                                                    activePlanInterval === "M" &&
                                                                                    activePlanDomain
                                                                                        .current_package_only.length &&
                                                                                    activePlanDomain
                                                                                        .current_package_only[0]
                                                                                        .is_cancel_offer_accept !== 1
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                            />
                                                                        </>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <Button
                                                                    variant="primary"
                                                                    size="lg"
                                                                    className="w-100"
                                                                    onClick={() => handlePurchase(planItem.id)}
                                                                    disabled={disabledButton}
                                                                >
                                                                    <>
                                                                        {(planTypeActive === 2 ||
                                                                        activePlanPrice === 0 ||
                                                                        isExpired) && !isFreeWidget
                                                                            ? t("Purchase Now")
                                                                            : t("Upgrade Plan")}
                                                                    </>

                                                                    {/* {(activePlanType === 3 && user && user.is_multiple_domain && !user.is_multi_domain_purchased)
                                                                        ? <>
                                                                            {(activePlanPrice === 0) ? t('Purchase Now') : t('Upgrade Plan')}
                                                                        </>
                                                                        : <>
                                                                            {currentWebsitePlanStatus.isExpired || currentWebsitePlanStatus.isCanceledPlan ? t('Purchase Now') : t('Upgrade Plan')}
                                                                        </>
                                                                    } */}
                                                                </Button>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}

                            {!activePlanDomain &&
                            upgradePlanList.map((planItem) => {
                                return (
                                    <Col key={planItem.id}>
                                        <Card className="aioa_dashboard-widget-plan-box">
                                            <Card.Header className="h5">
                                                <div className="aioa_dashboard-widget-plan-box-name">
                                                    <span>{planItem.name}</span>
                                                </div>
                                                <div className="aioa_dashboard-widget-plan-box-price">
                                                    {user &&
                                                    user.department === 4 &&
                                                    currentUserDiscount &&
                                                    currentUserDiscount.discount_value > 0 ? (
                                                        <>
                                                            {planInterval === "M" ? (
                                                                <>
                                                                    <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                                        <del className="me-2">
                                                                            <small>
                                                                                ${planItem.monthly_price.toFixed(2)}
                                                                            </small>
                                                                        </del>
                                                                        <br />
                                                                        $
                                                                        <StrikePrice
                                                                            price={planItem.monthly_price}
                                                                        />
                                                                        <span>/{t("Per Month")}</span>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                                        <>
                                                                            <del className="me-2">
                                                                                <small>
                                                                                    ${planItem.price.toFixed(2)}
                                                                                </small>
                                                                            </del>
                                                                            <br />
                                                                            $<StrikePrice price={planItem.price} />
                                                                            <span>/{t("Per Year")}</span>
                                                                        </>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {planInterval === "M" ? (
                                                                <>
                                                                    <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                                        <>${planItem.monthly_price}</>
                                                                        <span>/{t("Per Month")}</span>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="aioa_dashboard-widget-plan-box-offer-price">
                                                                        <>${planItem.price}</>
                                                                        <span>/{t("Per Year")}</span>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </Card.Header>
                                            <Card.Body>
                                                <div className="aioa_dashboard-widget-plan-box-description-wrapper">
                                                    <div className="aioa_dashboard-widget-plan-box-description">
                                                        {t("Plan Description Text", {
                                                            pageViews: planItem.page_views,
                                                        })}
                                                    </div>

                                                    {planType === 2 && (
                                                        <>
                                                            <div className="aioa_dashboard-widget-plan-domain-description">
                                                                {t("plan domain info", {
                                                                    domainCount:
                                                                        planItem.slug === "silver"
                                                                            ? 3
                                                                            : planItem.slug === "gold"
                                                                            ? 5
                                                                            : planItem.domain_limit
                                                                                ? planItem.domain_limit
                                                                                : 10,
                                                                })}
                                                            </div>
                                                        </>
                                                    )}

                                                    {planType === 3 && (
                                                        <>
                                                            <div className="aioa_dashboard-widget-plan-domain-description">
                                                                {t("plan domain info", {
                                                                    domainCount: planItem.domain_limit || 0,
                                                                })}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>

                                                <div className="aioa_dashboard-widget-plan-box-btn">
                                                    {user && forAddNewDomain ? (
                                                        <>
                                                            {planType === planTypeActive ? (
                                                                <>
                                                                    <Button
                                                                        variant="primary"
                                                                        size="lg"
                                                                        className="w-100"
                                                                        onClick={() =>
                                                                            handlePurchaseNormalDomainPlan(
                                                                                planItem.id
                                                                            )
                                                                        }
                                                                        disabled={disabledButton}
                                                                    >
                                                                        {t("Select Plan")}
                                                                    </Button>
                                                                    {user.department === 4 ||
                                                                    currentWebsite === null ? (
                                                                        <>
                                                                            <div className="pt-3 mt-3 border-top text-center">
                                                                                <a
                                                                                    role="button"
                                                                                    onClick={() =>
                                                                                        handlePurchaseWidgetPlan(
                                                                                            planItem.id,
                                                                                            true,
                                                                                            false
                                                                                        )
                                                                                    }
                                                                                    className={`${
                                                                                        disabledButton ? `pe-none` : ``
                                                                                    }`}
                                                                                    aria-disabled={`${
                                                                                        disabledButton ? `true` : `false`
                                                                                    }`}
                                                                                    tabIndex={disabledButton ? -1 : 0}
                                                                                >
                                                                                    {t("free trial btn label")}
                                                                                </a>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Button
                                                                variant="primary"
                                                                size="lg"
                                                                className="w-100"
                                                                onClick={() => handlePurchase(planItem.id)}
                                                                disabled={disabledButton}
                                                            >
                                                                {t("Purchase Now")}
                                                            </Button>
                                                        </>
                                                    )}
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </>
                    ) : (


                        <div className="no-paln">
                            <Card style={{ width: '70rem', border: '2px solid #420083', background: "linear-gradient(78deg, #D5D1FD 10.33%, #EDEBFF 121.25%)", padding: "20px" }}>
                                <Card.Body>
                                    <Card.Text>
                                        {activePlanDomain &&
                                        activePlanDomain.current_package_only &&
                                        activePlanDomain.current_package_only.length &&
                                        activePlanDomain.current_package_only[0].slug ===
                                        "large-site-10-domains"
                                            ? t("Contact us at 'hello@skynettechnologies.com'")
                                            : t("Contact us to upgrade or purchase a plan.")}
                                    </Card.Text>
                                </Card.Body>
                            </Card>

                        </div>
                    )}
                </Row>

            </div>

            <Modal
                show={isShowRemoveWebsitePopup}
                onHide={setRemoveWebsitePopup}
                centered
                size="lg"
                backdrop="static"
                fullscreen="lg-down"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Domain</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-danger mb-3 fw-semibold">
                        You currently have more domains than allowed by the selected plan.
                        Please remove one or more domains to proceed with selecting this
                        plan
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="lg" onClick={setRemoveWebsitePopup}>
                        {t("Cancel")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
export default UpgradePlanList;
